module.exports = __webpack_public_path__ + "static/media/REPORT-COUNT-2.8458b295.png";